module.exports = __webpack_public_path__ + "img/gear.6a5a34c0.jpg";